export { Icons19 } from "./Icons19";
